import { getGoogleAuthUrl } from '../../../api/endpoints';
import { Link } from 'react-router-dom';
import 'boxicons';

const OauthIcons = () => {

    return (
        <div className="d-flex gap-2">
            <Link to={getGoogleAuthUrl()}><box-icon size='lg' color='#F00A' type='logo' name='google'></box-icon></Link>
            <Link to={"http://facebook.com"}><box-icon size='lg' color='#55FA' type='logo' name='facebook'></box-icon></Link>
        </div>
    )

}

export default OauthIcons;